module.exports = __webpack_public_path__ + "6cc761a3024205fb86990100dc60a5f6.jpg";